<template>
    <div id="myChartBookForm">
        <div class="table-header">
            <div class="flex flex-wrap w-full">
                <div class="sm:flex-1 w-full pr-3 xs:pr-0 xs:pb-2">
                    <span class="btn btn-blue btn-xs" @click="addChart">
                        <i class="fas fa-plus"></i>
                        Add Chart Book
                    </span>
                </div>
                <div class="justify-center sm:ml-auto">
                    <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1 xs:ml-0" @click="close">Cancel</div>
                    <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="save">Save</div>
                </div>
            </div>
        </div>

        <alert-box v-if="chartbooks.length === 0">
            <template #body>
                You do not have any chartbooks.
            </template>
        </alert-box>

        <table v-if="chartbooks.length > 0" class="table table-striped table-hover border border-t-0">
            <thead>
                <tr>
                    <th class="w-16 text-center">Sort</th>
                    <th>Chart Book Name</th>
                    <th class="text-center" v-if="isJim()">Public</th>
                    <th class="w-24 text-center">Delete</th>
                </tr>
            </thead>
            <draggable v-model="chartbooks" tag="tbody" handle=".canDrag" item-key="id">
                <template #item="{ element, index }">
                    <tr>
                        <td class="text-center cursor-move canDrag">
                            <i class="fas fa-arrows-alt text-gray-500"></i>
                        </td>
                        <td>
                            <div class="error" v-show="element.error">{{ element.error }}</div>
                            <input :ref="`chartbook-${index}`" :class="{'is-invalid': element.error}" class="form-input-inline-w-none form-input-sm-inline w-full" type="text" v-model="element.name" maxlength="40" />
                        </td>
                        <td v-if="isJim()" class="text-center">
                            <input v-model="element.public" type="checkbox">
                        </td>
                        <td class="text-center">
                            <a @click="removeChartbook(index)" v-tooltip="{ content: 'Delete Current Chartbook', placement: 'auto-start', theme: 'red' }"  class="btn btn-default btn-shadow-none btn-red-ghost btn-xs ml-1 mb-1 md:mb-0" title="Delete Chartbook">
                                <i class="fas fa-times"></i>
                            </a>
                        </td>
                    </tr>
                </template>
            </draggable>
            <tfoot>
                <tr>
                    <th class="text-center">Sort</th>
                    <th>Chart Book Name</th>
                    <th class="text-center" v-if="isJim()">Public</th>
                    <th class="text-center">Delete</th>
                </tr>
            </tfoot>
        </table>

        <div class="flex justify-center mt-4">
            <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1 xs:ml-0" @click="close">Cancel</div>
            <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="save">Save</div>
        </div>

    </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
import Draggable from 'vuedraggable';
import { useIsJim } from '../../../mixins/IsJim';

const props = defineProps({
    initialChartbooks: {
        type: Array,
        required: true
    }
});

const emit = defineEmits(['close', 'save']);

const chartbooks = ref(JSON.parse(JSON.stringify(props.initialChartbooks)));
const { isJim } = useIsJim();

const hasChanged = () => {
    return JSON.stringify(props.initialChartbooks) !== JSON.stringify(chartbooks.value);
};

const close = () => {
    emit('close');
};

const validate = () => {
    let valid = true;

    chartbooks.value.forEach((chartbook, index) => {
        if (chartbook.name === '') {
            chartbook.error = 'Please enter a chartbook name';
            valid = false;
        }
    });

    return valid;
};

const save = () => {
    if (!validate()) {
        return;
    }

    const route = window.route('my-folder.chart-book.batch-update');
    axios.post(route, { chartbooks: chartbooks.value })
        .then(response => {
            emit('save', response.data.chartbooks);
        }).catch(error => {
            console.error(error);
        });
};

const addChart = () => {
    chartbooks.value.push({ name: '', public: isJim() });
    // nextTick(() => {
    //     this.$refs['chartbook-' + (chartbooks.value.length - 1)][0].focus();
    // });
};

const removeChartbook = (index) => {
    chartbooks.value.splice(index, 1);
};

const handleLeave = (e) => {
    if (hasChanged()) {
        e.preventDefault();
        e.returnValue = 'Are you sure?';
        return 'Are you sure?';
    }
};

onMounted(() => {
    window.addEventListener('beforeunload', handleLeave);
});

onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', handleLeave);
});
</script>

<style lang="scss">
#myChartBookForm {
    @apply border-t-2 border-blue-600 mt-4;
    table {
        thead,
        tfoot {
            td, th {
                @apply px-3 py-2;
            }
        }
        tbody {
            td, th {
                @apply px-3;
            }
        }
        .sortable {
            @apply cursor-pointer;
        }
    }
}
</style>
